module.exports = __webpack_public_path__ + "images/customer-service-qrcode-a8adc89f6b081661e13b52dba8d5b5a8.jpg";